import useApiMutation from '_api/mutations/useApiMutation';
import { Guardian, UpdateGuardianPayload } from '_api/types';

export const UPDATE_GUARDIAN_KEY = 'update-guadian-key';

export const useUpdateGuardian = () => {
  return useApiMutation<Guardian, UpdateGuardianPayload>(
    () => '/guardian',
    'put',
    {},
    {
      mutationKey: [UPDATE_GUARDIAN_KEY],
    },
    (body: UpdateGuardianPayload) => body,
  );
};
